import { ArrowRight } from "lucide-react";
import { Button } from "../Button";
import { CHECKOUT_URL } from "../../data/aquagym";
interface CheckoutButtonProps {
  label: string;
  inverse?: boolean;
}
export function CheckoutButton({
  label,
  inverse = false
}: CheckoutButtonProps) {
  const handleCheckout = () => {
    if (!CHECKOUT_URL.startsWith("https://")) {
      window.alert("Checkout pendiente: reemplazá CHECKOUT_URL_PENDIENTE_REEMPLAZAR antes de publicar.");
      return;
    }
    window.location.assign(CHECKOUT_URL);
  };
  return <div className="w-full max-w-xl" data-id="element-1" data-mp="2d9tpi1odqfwf">
      <Button type="button" size="lg" onClick={handleCheckout} className={`h-auto min-h-14 w-full whitespace-normal rounded-xl px-5 py-4 text-sm font-black tracking-wide shadow-[0_14px_35px_rgba(8,145,178,0.3)] transition-transform hover:-translate-y-0.5 sm:text-base ${inverse ? "bg-white text-[#075985] hover:bg-cyan-50" : "bg-[#06B6D4] text-[#083344] hover:bg-[#22D3EE]"}`} aria-label={label} data-id="element-2" data-mp="2d6pdii4oafv7">
        <span data-id="element-3" data-mp="27wm8un6z41a2">{label}</span>
        <ArrowRight className="ml-2 size-5 shrink-0" aria-hidden="true" data-id="element-4" data-mp="2cxjlyld4m54p" />
      </Button>
    </div>;
}